module.exports = __webpack_public_path__ + "5da2f7fe469630c3efa582737d626c92.png";